// extracted by mini-css-extract-plugin
export default {"card":"Card_card__eCk1w","perspective":"Card_perspective__0j2Xm"};